var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"companyHeader",style:({ backgroundImage: ("url(" + _vm.headerImg + ")") })},[_c('h1',{staticClass:"heading-primary text-center",style:({ color: _vm.textColor })},[_vm._v(" "+_vm._s(_vm.h1Content)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }